export module API_ENDPOINTS {

    /**
     * Naming Convention
     * Level 1 : Based on Action and Page (Example: AUTH, LANDING_PAGE, USAGE, etc)
     * Level 2 : Specific URL to API 
     * 
     */
    export const AUTH = {
        LOGIN: '/api/user/login',         //login to the portal
        REGISTER: '/api/user/register',      //register new user
        REFRESH: '/api/user/renewToken',        //refresh access / id token
        FORCE_CHANGE_PASSWORD: '/api/user/forceChangePassword',
        FORGOT_PASSWORD: '/api/user/forgotPassword',
        CONFIRM_FORGOT_PASSWORD: '/api/user/confirmForgotPassword',
        LOGOUT: '/api/user/logout',
        UNIQUE: '/api/user/unique',//Kowsalya
        RESEND_CODE: '/api/user/resendCode',
        CONFIRM_REGISTRATION: '/api/user/confirmRegistration',
        NODE_TEST: '/api/plantmap/updateS3Status',
        PAYMENT_CHECK: '/api/plantmap/requestMPGSSession',
        GET_PAYMENT: '/api/service/getMPGSPayment'
    };

    export const ACCOUNT = {
        CHANGE_PASSWORD: '/api/user/changePassword',
        GET_SECURITY_QUESTION: '/api/user/getSecurityQuestion',
        VALIDATE_SECURITY_QUESTION: '/api/user/validateSecurityQuestion',
        CHANGE_SECURITY_QUESTION: '/api/user/changeSecurityQuestion',
        USER_PROFILE: '/api/user/getUserProfile',
        UPDATE_USER_PROFILE: '/api/user/updateUserProfile',
        PAYMENT_CREDENTIAL: '/api/user/getPaymentAvailability',
        CREATE_SECURITY_QUESTIION: '/api/user/createSecurityQuestion'
    }

    export const ADMIN = {
        GET_ALL_USER: '/api/admin/getAllUsers',
        GET_TOTAL_USER: '/api/admin/getTotalUsers',
        GET_USER_PROFILE: '/api/admin/getUserProfile',
        CREATE_ACCOUNT: '/api/admin/createAccount',
        GET_INTERNAL_ROLES: '/api/admin/getInternalRoles',
        GET_ALL_ROLES: '/api/admin/getAllRoles',
        RESET_USER_PASSWORD: '/api/admin/resetUserPassword',
        CONFIRM_RESET_PASSWORD: '/api/admin/confirmResetPassword',
        CHANGE_ROLE: '/api/admin/changeRole'
    }

    export const PLANT_MAP = {
        GET_ALL_STATUS: '/api/plantmap/getAllStatus',
        GET_USER_PLANTMAP: '/api/plantmap/getAvailablePlantmap',
        GET_USER_PLANTMAP_ADMIN: '/api/plantmap/getAvailablePlantmapAdmin', //GANESH
        GET_USER_PLANTMAP_DATE: '/api/plantmap/getAvailablePlantmapDate',
        GET_USER_PLANTMAP_DATE_ADMIN: '/api/plantmap/getAvailablePlantmapDateAdmin', //GANESH
        GET_USER_TOTAL_PLANTMAP: '/api/plantmap/getTotalPlantmap',
        GET_USER_TOTAL_PLANTMAP_ADMIN: '/api/plantmap/getTotalPlantmapAdmin',//GANESH
        GET_USER_TOTAL_PLANTMAP_DATE: '/api/plantmap/getTotalPlantmapDate',
        GET_USER_TOTAL_PLANTMAP_DATE_ADMIN: '/api/plantmap/getTotalPlantmapDateAdmin',//GANESH
        GET_DETAIL_PLANTMAP: '/api/plantmap/getDetailPlantmap',
        VERIFY_MAP: '/api/plantmap/verifyMap',
        CREATE_TEMPORARY_PLANTMAP: '/api/plantmap/createTemporaryPlantmap',
        UPDATE_TEMPORARY_PLANTMAP: '/api/plantmap/updateTemporaryPlantmap',
        CREATE_PLANTMAP_NO_RESTRICTED: '/api/plantmap/createPlantmapNoRestrictedArea',
        CREATE_PLANTMAP_ATTACHMENT: '/api/plantmap/createPlantmapAttachmentRestricted',
        GET_STATUS: '/api/plantmap/getStatus',
        CHECK_STATUS: '/api/plantmap/checkPlantmapStatus',
        LOAD_TRANSACTION: '/api/plantmap/loadTransaction',
        GIS_HIT: '/api/plantmap/gisPlantmapHit',
        EDIT_PLANTMAP: '/api/plantAdmin/editDetailPlantmap',
        CHECK_DAILY_LIMIT: '/api/plantmap/checkdailylimit',
        CHECK_TRANS_HIS_VAL: '/api/plantmap/validateTransactionHistory', //Kowsalya
        DOWNLOAD_EXCEL: '/api/plantmap/downloadExcel', //Kowsalya
        DOWNLOAD_EXCEL_BYDATE: '/api/plantmap/downloadExcelBydate', //Kowsalya
        GET_PLAD_PLANTMAP_DATE: '/api/plantmap/getAvailablePlantmapDatePlad',//Kowsalya
        GET_PLAD_PLANTMAP_TOTAL_DATE: '/api/plantmap/getTotalPlantmapDatePlad', //Kowsalya
        PLANTMAP_INVOICE: '/api/plantmap/pushInvoicetoS3', //Kowsalya
        PLANTMAP_REGENERATE_STATUS: '/api/plantmap/updateRegenerateStatus',
        GIS_HIT_ADMIN: '/api/plantmap/gisPlantmapHitAdmin',
        USER_DETAIL: '/api/plantmap/userdetail', //Kowsalya,
        SUNVIZON143: '/api/plantmap/sunvizonUploadToDMS143',
        NOTIFICATION618: '/api/plantmap/notificationApi618',
        ZIPFILEDMSDOWNLOAD: '/api/plantmap/downloadZipFromDMS',
        REGENRATE_PLANTMAP_HIT_ADMIN: '/api/plantmap/regeneratePlantMapHitAdmin',

    };

    export const PLANT_MAP_ADMIN = {
        GET_ALL_STATUS: '/api/plantAdmin/getAllStatus',
        GET_PLAD_PLANTMAP: '/api/plantAdmin/getAvailablePlantmap',
        GET_PLAD_TOTAL_PLANTMAP: '/api/plantAdmin/getTotalPlantmap',
        GET_DETAIL_PLANTMAP: '/api/plantAdmin/getDetailPlantmap',
        PRINT_MAP: '/api/plantAdmin/printPlantmap',
        REPRINT_MAP: '/api/plantAdmin/gisPlantmapHit'
    }

    export const NCE = {
        GET_ALL_STATUS: '/api/nce/getAllStatus',
        GET_ALL_NCE: '/api/nce/getAvailableNCE',
        GET_TOTAL_NCE: '/api/nce/getTotalNCE',
        CREATE_TEMPORARY_NCE: '/api/nce/createTemporaryNCE',
        UPDATE_TEMPORARY_NCE: '/api/nce/updateTemporaryNCE',
        CHECK_STATUS: '/api/nce/checkNCEStatus',
        CREATE_TEMP_EXTENSION: '/api/nce/createTemporaryExtension',
        CREATE_EXTENSION: '/api/nce/createExtension',
        PREVIEW: '/api/nce/preview',
        GET_APPOINTMENT_AVAILABILITY: '/api/nce/getAppointmentAvailability',
        GET_AVAILABLE_TIME: '/api/nce/getAvailableTime',
        CREATE_APPOINTMENT: '/api/nce/createAppointment',
        CREATE_ATTACHMENT: '/api/nce/createAttachment',
        LOAD_TRANSACTION: '/api/nce/loadTransaction',
        LOAD_TRANSACTION_EXTENSION: '/api/nce/loadTransactionExtension',
        GET_STATUS: '/api/nce/getStatus',
        GET_NCE_PRICE: '/api/nce/getNCEPrice',
        GET_NCE_EXT_PRICE: '/api//nce/getNCEExtensionPrice',
        GET_REFERENCE_ID: '/api/nce/getReferenceId',
        UPDATE_STATUS: '/api/nce/updateStatus',
        EDIT_NCE: '/api/nceAdmin/editDetailNCE',
        APPLICATION_FOR_FINAL_APPROVAL: '/api/nce/applyForFinalApproval',
    };

    export const NCE_ADMIN = {
        GET_ALL_STATUS: '/api/nceAdmin/getAllStatus',
        GET_ALL_NCE: '/api/nceAdmin/getAvailableNCE',
        GET_TOTAL_NCE: '/api/nceAdmin/getTotalNCE',
        PREVIEW: '/api/nceAdmin/preview',
        CHANGE_APPOINTMENT: '/api/nceAdmin/changeAppointmentDate',
        UPDATE_STATUS: '/api/nceAdmin/updateStatus',
        CREATE_ATTACHMENT: '/api/nceAdmin/createAttachment',
        GET_LINK_CSV: '/api/nceAdmin/getLinkCSV',
        GET_DETAIL_LINK_CSV: '/api/nceAdmin/getInnerLinkCSV',
    }

    export const FILE = {
        UPLOAD: '/api/service/getUploadUrl',
        DOWNLOAD: '/api/service/getDownloadUrl',
        DOWNLOAD_MISC: '/api/service/getMiscDownloadUrl',
        DELETE_FILES: '/api/service/deleteFiles',

        DOWNLOAD_PLANTMAP: '/api/service/getPlantMapDownloadUrl'

    }

    export const ONEMAP = {
        SEARCH: 'https://www.onemap.gov.sg/api/common/elastic/search'
    };
    // had to be changed from below to above URL, due to upgradation of One Map’s APIs
    // old url: https://developers.onemap.sg/commonapi/search?searchVal=INDIA&returnGeom=Y&getAddrDetails=Y&pageNum=1

}




// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/configuration/api-endpoints.ts